export default [
  {
    path: '/error-404',
    name: 'error-404',
    component: () => import('@/views/error/Error404.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      action: 'read',
    },
  },
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/pages/Home.vue'),
  },
  {
    path: '/:template_id(\\d+)',
    name: 'home-template',
    component: () => import('@/views/pages/Home.vue'),
  },
]
